'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/syntax.js
// module id = 1546
// module chunks = 1